import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminLayout } from './AdminLayout';
import { DashboardPage } from './pages/DashboardPage';
import { WorkspacesPage } from './pages/WorkspacesPage';
import { WorkspaceReportPage } from './pages/WorkspaceReportPage';
import { UsersPage } from './pages/UsersPage';
import { ChatsPage } from './pages/ChatsPage';
import { DocumentsPage } from './pages/DocumentsPage';
import { FeedbacksPage } from './pages/FeedbacksPage';
import { PaymentsPage } from './pages/PaymentsPage';
import { BlogAnalyticsPage } from './pages/BlogAnalyticsPage';
import { SharesPage } from './pages/SharesPage';

export function AdminApp() {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="workspaces" element={<WorkspacesPage />} />
        <Route path="workspaces/:workspaceId/report" element={<WorkspaceReportPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="chats" element={<ChatsPage />} />
        <Route path="documents" element={<DocumentsPage />} />
        <Route path="feedbacks" element={<FeedbacksPage />} />
        <Route path="payments" element={<PaymentsPage />} />
        <Route path="shares" element={<SharesPage />} />
        <Route path="blog-analytics" element={<BlogAnalyticsPage />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Route>
    </Routes>
  );
}
